<template>
  <div class="trigger-manual-editor">
    <!-- Node Intro -->
    <div class="node-intro">
      <div class="node-icon">
        <svg preserveAspectRatio="none" width="100%" height="100%" overflow="visible" style="display: block;" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g fill-rule="evenodd" clip-rule="evenodd">
            <path d="M8.33333 0C3.73333 0 0 3.73333 0 8.33333C0 12.9333 3.73333 16.6667 8.33333 16.6667C12.9333 16.6667 16.6667 12.9333 16.6667 8.33333C16.6667 3.73333 12.9333 0 8.33333 0ZM8.33333 15C4.65833 15 1.66667 12.0083 1.66667 8.33333C1.66667 4.65833 4.65833 1.66667 8.33333 1.66667C12.0083 1.66667 15 4.65833 15 8.33333C15 12.0083 12.0083 15 8.33333 15Z" fill="#20a7c1"/>
            <path d="M9.575 7.81667C9.93333 6.8 9.71667 5.61667 8.9 4.8C7.975 3.875 6.575 3.71667 5.48333 4.30833L7.44167 6.26667L6.26667 7.44167L4.30833 5.48333C3.71667 6.58333 3.875 7.975 4.8 8.9C5.61667 9.71667 6.8 9.93333 7.81667 9.575L10.6583 12.4167C10.825 12.5833 11.0833 12.5833 11.25 12.4167L12.4167 11.25C12.5833 11.0833 12.5833 10.825 12.4167 10.6583L9.575 7.81667Z" fill="#20a7c1"/>
          </g>
        </svg>
      </div>
      <p class="node-description">
        <span class="node-title">Manual Start</span> trigger a workflow manually (by patient assignment).
      </p>
    </div>

    <!-- Info Box -->
    <div class="info-box">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style="flex-shrink:0">
        <path d="M9 5H11V7H9V5ZM9 9H11V15H9V9ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z" fill="#20A7C1"/>
      </svg>
      <p class="info-text">Workflow will be triggered immediately upon assignment to a patient.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TriggerManualEditor',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  mounted() {
    this.$emit('save', { configured: true });
  }
};
</script>

<style scoped>
.trigger-manual-editor {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

/* Node Intro */
.node-intro {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  padding: 8px 16px;
  background: #E5F9EF;
  border-radius: 5px;
}

.node-icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.node-description {
  flex: 1;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 300;
  line-height: 18px;
  color: #20A7C1;
  margin: 0;
}

.node-title {
  font-weight: 700;
}

/* Input Section */
.input-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.input-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.input-label {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #4A4A4A;
  height: 24px;
  display: flex;
  align-items: center;
}

/* Info Box */
.info-box {
  display: flex;
  gap: 8px;
  align-items: flex-start;
  padding: 12px;
  background: #E3F2FD;
  border: 1px solid #90CAF9;
  border-radius: 4px;
}

.info-text {
  flex: 1;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #004879;
  margin: 0;
}

.info-description {
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: #333;
  margin: 0;
}

/* Save Configuration Button */
.save-config-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 32px;
  padding: 4px 8px;
  background: #004879;
  border: none;
  border-radius: 4px;
  box-shadow: 0px 1px 3px 0px rgba(74, 74, 74, 0.25);
  cursor: pointer;
  transition: background 0.2s ease;
  width: 100%;
}

.save-config-btn:hover {
  background: #003366;
}

.save-config-btn:active {
  transform: translateY(1px);
}

.btn-icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.save-config-btn span {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: white;
}
</style>
